export default "__VITE_ASSET__74c6ad80__"